import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withTheme } from 'emotion-theming';
import { Backdrop } from '../../components/Themed.js';
import { getIntakeForms, getCustomFields } from '../../data/app/AppActions.js';
import { getEmployees } from '../../data/employee/EmployeeActions.js';
import {
  setClientInformation,
  setClientChildInformation,
  createClient,
  updateClient,
} from '../../data/client/ClientActions.js';
import {
  getIntakeFields,
  getFamilyMemberTerm,
} from '../../data/app/AppReducer';
import NewClient from '../../components/new-client/new-client.jsx';
import './ClientForm.css';
import { isLocaleOrCountryInternational } from '../../common/utils.js';

class ClientForm extends React.Component {
  constructor(props) {
    super(props);

    this.clientSave = this.clientSave.bind(this);
  }

  async componentDidMount() {
    const {
      intakeForms,
      customFields,
      employees,
      getIntakeForms,
      getCustomFields,
    } = this.props;

    if (!intakeForms || !customFields || !employees) {
      await Promise.all([getIntakeForms(), getCustomFields(), getEmployees()]);
    }
  }

  clientSave() {
    const {
      createClient,
      clientInformation,
      updateClient,
      companyChildType,
      language,
    } = this.props;

    clientInformation.companyChildType = companyChildType;
    clientInformation.preferred_language = language

    if (!clientInformation.id) {
      return createClient(clientInformation).then(res => {
        if (res) {
          this.props.history.push('/services/0');
        }
      });
    } else {
      return updateClient(clientInformation, this.props.hasChildren).then(
        res => {
          if (res) {
            this.props.history.push('/services/0');
          }
        }
      );
    }
  }

  render() {
    const fields = getIntakeFields(
      this.props.intakeForms,
      this.props.customFields,
      true
    );

    const {
      localeUUID,
      locationCountryCode
    } = this.props

    const isInternational = isLocaleOrCountryInternational(localeUUID, locationCountryCode)

    return (
      <React.Fragment>
        <Backdrop id="backdrop" />
        <div className="scroll-container content-container">
          <div className="page-container">
            <div className="return-client">
              <div className="content-medium content-edge-bottom-padded">
                <NewClient
                  ifis={fields}
                  mandatoryFields={true}
                  employees={this.props.employees}
                  ui={{ theme_color: this.props.theme.themeColor }}
                  client={this.props.clientInformation}
                  onChange={newClient =>
                    this.props.setClientInformation(newClient)
                  }
                  hasChildren={this.props.hasChildren}
                  children={this.props.clientInformation.children}
                  onChildChange={(newChild, childIndex) =>
                    this.props.setClientChildInformation(newChild, childIndex)
                  }
                  onComplete={this.clientSave}
                  errors={this.props.clientSaveError}
                  isNewClient={true}
                  familyMemberTerm={this.props.familyMemberTerm}
                  isInternational={isInternational}
                />
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    isNewClient: state.client.isNewClient,
    hasChildren: state.client.hasChildren,
    hasServicesForClient: state.client.hasServicesForClient,
    clientInformation: state.client.clientInformation,
    clientSaveError: state.client.clientSaveError,
    companyName: state.app.businessInfo.company.name,
    companyChildType: state.app.businessInfo.company.child_type,
    intakeForms: state.app.intakeForms,
    customFields: state.app.customFields,
    employees: state.employee.employees,
    familyMemberTerm: getFamilyMemberTerm(state.app.businessInfo),
    localeUUID: state.app.businessInfo.company.locale_uuid,
    language: state.app.language,
    locationCountryCode: state.app.businessInfo.company.default_country,
  };
}

export default withRouter(
  withTheme(
    connect(
      mapStateToProps,
      {
        getIntakeForms,
        getCustomFields,
        getEmployees,
        setClientInformation,
        setClientChildInformation,
        createClient,
        updateClient,
      }
    )(ClientForm)
  )
);
